<template>
    <div class="wrapper">
      <div class="header">
        <el-row class="header-warp">
          <el-col :span="12">
            <router-link to="/stockmarket/rise">
              <h3 class="header-title"><i class="el-icon-s-marketing"></i>&nbsp;<span>行情中心</span></h3>
            </router-link>
          </el-col>
          <el-col :span="5">
            <p class="header-time"><i class="el-icon-time time-color"></i>&nbsp;&nbsp;香港时间:<span>{{time}}</span></p>
          </el-col>
          <el-col :span="7">
            <el-select v-model="state" filterable remote :remote-method="remoteMethod" :loading="loading" @change="openDetailed" placeholder="代码/名称/简拼" size="small" class="full_width">
              <el-option
                v-for="item in options"
                :key="item.short"
                :label="item.name +' '+item.code"
                :value="item.short">
              </el-option>
            </el-select>

            <!--<el-autocomplete placeholder="代码/名称/拼音" :fetch-suggestions="querySearchAsync"  @select="handleSelect" v-model="state" class="input-with-select" size="small" style="width: 100%">
              <el-select v-model="stockSuggest" slot="prepend" placeholder="请选择" class="search-select">
                <el-option label="沪" value="sh" selected></el-option>
                <el-option label="深" value="sz"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click="openDetailed"></el-button>
            </el-autocomplete>-->
          </el-col>
          <!--<el-col :span="1">
            <el-button type="primary" icon="el-icon-search" size="small" class="full_width" @click="openDetailed"></el-button>
          </el-col>-->
        </el-row>
      </div>
    </div>
</template>

<script>
  import eventBus from "../assets/js/eventBus";
    export default {
        name: "stockheader",
      data(){
          return{
            time: '',
            state: '',   //模糊搜索
            stockSuggest: 'hk',
            timeout:  null, //定时器
            restaurants: [],
            loading:false,
            options:[],
          }
      },
      methods: {
        // 获取右上角实时时间
        getTime() {
          let that = this;
          this.timer = setInterval(function () {
            that.time = that.$moment().tz("Asia/Shanghai").format("YYYY-MM-DD HH:mm:ss");
          },1000)
        },
        querySearchAsync(queryString, cb) {
          var restaurants = this.restaurants;
          var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : [{
            short : 'sz000001',
            code : '000001',
            name : '平安银行',
            pinyin : 'PAYX',
            value : 'sz000001 平安银行 PAYX'
          }];
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results);
          }, 3000 * Math.random());
        },

        remoteMethod(query) {
          let that = this;
          if (query !== '') {
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
              this.options = that.restaurants.filter(item => {
                return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.short.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.pinyin.toLowerCase().indexOf(query.toLowerCase()) > -1;
              });
            }, 200);
          } else {
            this.options = [];
          }
        },


        createStateFilter(queryString) {
          return (state) => {
            return (state.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || state.code.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || state.pinyin.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
          };
        },
        handleSelect(item) {
          this.stockSuggest = item.short.substr(0,2).trim();
          this.state = item.code.trim();
          this.symbol = item.short.trim();
        },
        loadAll() {
          let that = this;
          that
            .$http({
            url: "/",             //请求地址
              method: "post",
            data:{
              'nozzle': 'all_stock',
            }
          })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                for (let i = 0,len = resData.data.length; i < len; i++){
                  resData.data[i].value = resData.data[i].short + ' '+ resData.data[i].name + ' ' + resData.data[i].pinyin;
                }
                that.restaurants = resData.data;
                that.$store.commit('addRestaurants',that.restaurants);
              }else{
                that.$alert('请稍后尝试','提示',{
                  confirmButtonText: '确定',
                  callback: action => that.loadAll()
                })
              }
            });
        },
        openDetailed(){
          let that = this;
          eventBus.$emit("symbol", that.state.trim());
           // this.$router.push({ name: 'Stockdetailed', query: { symbol:that.stockSuggest.trim()+that.state.trim() }});
          this.$router.push({ name: 'Stockdetailed', query: { symbol:that.state.trim() }});
        }
      },
      mounted() {
        let that = this;
        this.getTime();
        this.loadAll();
      },
      beforeDestroy(){
        clearInterval(this.timer);
      }
    }
</script>

<style scoped>
  .wrapper{
    width: 100%;
    margin: 0 auto;
    background: #FFFFFF;
  }
  .header{
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    min-width: 1000px;
  }
  .header-warp{
    height: 70px;
    display: flex;
    align-items: center; /*定义body的元素垂直居中*/
  }
  .header-title{
    font-size: 25px;
    color: #2162bd;

  }
  .header-time{
    font-size: 14px;
  }
  .time-color{
    font-size: 20px;
    background: #2162bd;
    color: white;
  }
  .search-select{
    width: 70px;
  }
  .full_width{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/stockheader.vue